import { render, staticRenderFns } from "./ShoppingCar.vue?vue&type=template&id=2e67670e&scoped=true&"
import script from "./ShoppingCar.vue?vue&type=script&lang=js&"
export * from "./ShoppingCar.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCar.vue?vue&type=style&index=0&id=2e67670e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e67670e",
  null
  
)

export default component.exports